import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const RelatedProjects = ({ fileJsonChildren }) => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="related-projects my-2 mb-4">
      <p>Más proyectos</p>
      <div className="row">
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={true}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
        >
          {Object.values(fileJsonChildren).map(
            (element, key) =>
              element.image !== undefined && (
                <div className="recuadro">
                  <a href={`${key}`}>
                    <img src={element.image} alt="" />
                  </a>
                </div>
              )
          )}
        </Carousel>
      </div>
    </div>
  );
};
export default RelatedProjects;
